<template>
  <div class="layout">
    <headerVue></headerVue>
    <div class="main-content" :class="{ 'full-width': isFullWidth }">
      <router-view></router-view>
      <!-- 主要内容区域 -->
    </div>
    <footerVue></footerVue>
  </div>
</template>

<script>
import headerVue from "./header.vue";
import footerVue from "./footer.vue";
export default {
  components: {
    headerVue,
    footerVue,
  },
  data() {
    return {};
  },
  computed: {
    isFullWidth() {
      // 股票页面(stockTable.vue)需要全宽布局，以便右侧面板可以挤压内容
      return this.$route.name === '股票';
    }
  }
};
</script>

<style lang="scss" scoped>
.layout {
  // width: 1440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh; /* 确保至少占满整个屏幕高度 */
  position: relative;

  // &::before {
  //   width: 100%;
  //   content: '';
  //   position: absolute;
  //   height: 1px;
  //   background: rgba(0, 0, 0, 0.2);
  //   left: 50%;
  //   transform: translateX(-50%);
  //   top: 56px;
  // }
}

.main-content {
  width: 1120px;
  max-width: 1120px;
  flex: 1; /* 主要内容区域自动撑开，footer 会被推到最下面 */
  // overflow: hidden;

  &.full-width {
    width: 100% !important;
    max-width: none !important;
    display: flex; /* 确保子元素(stockTable)可以利用flex布局 */
    flex-direction: column;
  }
}
</style>
